// src/services/convertkit-service.js
// ConvertKit integration — frontend service for OAuth + subscriber sync.

import { getFunctions, httpsCallable } from 'firebase/functions';

const REGION = 'us-west1';

function ck(name) {
  return httpsCallable(getFunctions(undefined, REGION), name, { timeout: 60000 });
}

/**
 * Start ConvertKit OAuth flow.
 * Calls the Cloud Function to get the OAuth URL, then redirects the browser.
 */
export async function initiateConvertKitConnect() {
  const result = await ck('initiateConvertKitAuth')();
  const url = result.data?.url;
  if (!url) throw new Error('Failed to get ConvertKit auth URL');
  window.location.href = url;
}

/**
 * Disconnect ConvertKit — removes stored tokens and clears convertkitConnected flag.
 */
export async function disconnectConvertKit() {
  const result = await ck('disconnectConvertKit')();
  return result.data;
}

/**
 * Sync all active DF subscribers to ConvertKit.
 * Returns { synced: number }.
 */
export async function syncAllToConvertKit() {
  const result = await ck('syncAllToConvertKit')();
  return result.data;
}
